import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

import app from '@/store/modules/app'
import createdSaleOrder from './modules/createdSaleOrder'
import guestCreatedSaleOrder from './modules/guestCreatedSaleOrder'
import guestSaleDetail from './modules/guestSaleDetail'
import crossings from '@/store/modules/crossings'
import invoiceableSales from '@/store/modules/invoiceableSales'
import invoices from '@/store/modules/invoices'
import payments from '@/store/modules/payments'
import products from './modules/products'
import rechargeForm from '@/store/modules/rechargeForm'
import rechargeCardForm from '@/store/modules/rechargeCardForm'
import rechargeTagForm from '@/store/modules/rechargeTagForm'
import rechargeSaleDetail from '@/store/modules/rechargeSaleDetail'
import saleDetail from '@/store/modules/saleDetail'
import saleOrderForm from '@/store/modules/saleOrderForm'
import sales from '@/store/modules/sales'
import subusers from '@/store/modules/subusers'
import user from './modules/user'
import vehicles from './modules/vehicles'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    createdSaleOrder,
    guestCreatedSaleOrder,
    guestSaleDetail,
    crossings,
    invoiceableSales,
    invoices,
    payments,
    products,
    rechargeForm,
    rechargeCardForm,
    rechargeTagForm,
    rechargeSaleDetail,
    saleDetail,
    saleOrderForm,
    sales,
    subusers,
    user,
    vehicles
  },
  getters
})

export default store
